<form class="form-container" [formGroup]="dniForm">
    <div class="form-field">
        <label class="form-label dni-label" for="dni">
            {{keyTranslate + '.dni' | translate}}
        </label>
        <input class="form-input" id="dni" maxlength="9" type="text" [formControl]="getControl('dni', 'dniForm')">
        <div *ngIf="getControl('dni', 'dniForm').invalid && (getControl('dni', 'dniForm').dirty || getControl('dni', 'dniForm').touched)"
            class="errorForm">
            {{keyTranslate + '.validations.dni' | translate}}
        </div>
    </div><!-- Cierre DNI -->
</form>

<form class="form-container" [formGroup]="clientForm" *ngIf="get_dni_done">
    <div class="dflex">
        <div class="form-field">
            <label class="form-label" for="nombre">
                {{keyTranslate + '.name' | translate}}
            </label>
            <input class="form-input" id="nombre" type="text" maxlength="50" [formControl]="getControl('nombre')">
            <div *ngIf="getControl('nombre').invalid && (getControl('nombre').dirty || getControl('nombre').touched)"
                class="errorForm">
                {{keyTranslate + '.validations.isEmpty' | translate}}

            </div>
        </div>

        <div class="form-field">
            <label class="form-label" for="apellidos">
                {{keyTranslate + '.surname' | translate}}
            </label>
            <input class="form-input" id="apellidos" type="text" maxlength="50" [formControl]="getControl('apellidos')">
            <div *ngIf="getControl('apellidos').invalid && (getControl('apellidos').dirty || getControl('apellidos').touched)"
                class="errorForm">
                {{keyTranslate + '.validations.isEmpty' | translate}}
            </div>
        </div>
    </div><!-- Cierre Nombre / apellido -->

    <div class="dflex">
        <div class="form-field">
            <label class="form-label" for="email">
                {{keyTranslate + '.email' | translate}}
            </label>
            <input class="form-input" id="email" type="email" [formControl]="getControl('email')">
            <div *ngIf="getControl('email').invalid && (getControl('email').dirty || getControl('email').touched)"
                class="errorForm">
                {{keyTranslate + '.validations.email' | translate}}
            </div>
        </div>

        <div class="form-field">
            <label class="form-label" for="telefono">
                {{keyTranslate + '.phone' | translate}}
            </label>
            <input class="form-input" id="telefono" type="text" maxlength="12" [formControl]="getControl('telefono')">
            <div *ngIf="getControl('telefono').invalid && (getControl('telefono').dirty || getControl('telefono').touched)"
                class="errorForm">
                {{keyTranslate + '.validations.phone' | translate}}
            </div>
        </div><!-- Cierre Telefono -->
    </div>

    <div class="dflex">
        <div class="form-field">
            <label class="form-label" for="direccion">
                {{keyTranslate + '.address' | translate}}
            </label>
            <input class="form-input" id="direccion" type="text" [formControl]="getControl('direccion')">
            <div *ngIf="getControl('direccion').invalid && (getControl('direccion').dirty || getControl('direccion').touched)"
                class="errorForm">
                {{keyTranslate + '.validations.isEmpty' | translate}}
            </div>
        </div>

        <div class="form-field">
            <label class="form-label" for="codigoPostal">
                {{keyTranslate + '.postalCode' | translate}}
            </label>
            <input class="form-input" id="codigoPostal" type="text" maxlength="5"
                [formControl]="getControl('codigoPostal')">
            <div *ngIf="getControl('codigoPostal').invalid && (getControl('codigoPostal').dirty || getControl('codigoPostal').touched)"
                class="errorForm">
                {{keyTranslate + '.validations.isEmpty' | translate}}
            </div>
        </div>
    </div><!-- Cierre Dirección / Código Postal -->
    <!-- <button type="submit">Enviar datos</button> -->
</form>